import React, { useState, useEffect } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editsubcategory(){
    const apiUrl = API_URL;
    const subcatId = useParams();
    const getsubcatid = subcatId.subcategoryid;
    const [items, setItems] = useState([]);
    const [subcat, setSubcat] = useState([]);
    const [categorylist, setCategorylist] = useState([]);
    const [categoryvalue,setCategoryvalue] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [addkey, setaddkey] = useState("");
    const [upaddkey, setUpaddkey] = useState('');

    useEffect(()=>{
        const editsubCat = async (e) =>{
            try{
                const postData = {
                    subcategory_id: getsubcatid
                };
                const result = await fetch(`${apiUrl}/admin/editsubcategorylist`,{
                    method: "POST",
                    headers: {
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body: JSON.stringify(postData)
                })
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setCategorylist(data.data.categorylist);
                setSubcat(data.data.subcategoryname);
                setaddkey(data.data.keywords)
                setItems(data.data);
            }
            catch(error){
                console.log('Error: ', error);
            }
        }
        editsubCat();
    },[]);

    const newaddkey = (e) => {
        setaddkey(e.target.value)
        setUpaddkey(e.target.value);
    }

    const updateSubcategory = async(e) => {
        e.preventDefault();
        let catid = '';
        if(categoryvalue.length == 0){
            catid = items.categoryId
        }
        else{
            catid = categoryvalue
        }
        try{
            const postData={
                subcategory_id:getsubcatid,
                subcategory_name:subcat,
                cat_id: catid,
                // keywords: addkey
                keywords: upaddkey
            }
            const result = await fetch(`${apiUrl}/admin/updatesubcategory`,{
                method: "POST",
                headers: {
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body: JSON.stringify(postData)
            });
            const data = await result.json();
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
            if(data.status !== 200){
                throw new Error('Data not found');
            }
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Subcategory</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={updateSubcategory}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="categoryname">Subcategory Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="categoryname" value={subcat} onChange={(e)=>setSubcat(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="categorytype">Category Type:</label>
                        <select className="form-select col-sm-5 selectBox" onChange={(e)=>setCategoryvalue(e.target.value)}>
                            <option value={items.categoryId ? items.categoryId:'Please Select category name'}>{items.categoryname ? items.categoryname:'Please Select category name'}</option>
                            {categorylist.map((item, index) => {
                                return(<option value={item.catdId}>{item.category_name}</option>
                            )})}
                        </select>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="subcategorykeywords">Add Keywords:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>newaddkey(e)} className="form-control" id="subcategorykeywords" placeholder="keyword1, keyword2" value={addkey}/>
                        </div>
                        <span className='d-block mt-2'>Keywords must be comma separated</span>
                        {/* <div className="col-sm-4">
                            <input type="text" onChange={(e)=>setaddkey(e.target.value)} className="form-control" id="subcategorykeywords" placeholder="keyword1, keyword2" value={addkey}/>
                        </div>
                        <span className='d-block mt-2'>Keywords must be comma separated</span> */}
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Editsubcategory;